<!-- Main view/routes wrapper-->
<div toastContainer></div>
<ng-container *ngIf="!isLoggedIn">
  <router-outlet></router-outlet>
</ng-container>
<!-- Wrapper-->
<div id="wrapper" *ngIf="isLoggedIn">
  <!-- Left navigation bar -->
  <navigation></navigation>

  <!-- Main page wrapper -->
  <div id="page-wrapper" class="background1">
    <!-- Top navigation -->
    <topnavbar *ngIf="!hideToolbar"></topnavbar>

    <!-- Main view/routes wrapper-->
    <router-outlet></router-outlet>

    <!-- Footer -->
    <!-- <footer></footer> -->
  </div>
  <!-- End page wrapper-->
</div>
<!-- End wrapper-->
<pp360-spinner [userInfo]="userDetails"></pp360-spinner>
